(() => {
  const BODY_CLASS = 'casa-silp-page-hide-chrome';

  function initialisePage(root) {
    if (!root || root.dataset.cspInitialised === 'true') return;
    root.dataset.cspInitialised = 'true';

    if (root.dataset.hideChrome === 'true') {
      document.body.classList.add(BODY_CLASS);
    }

    const hours = root.querySelector('[data-csp-hours]');
    const minutes = root.querySelector('[data-csp-minutes]');
    const seconds = root.querySelector('[data-csp-seconds]');
    if (!hours || !minutes || !seconds) return;

    const duration = Math.max(60, Number(root.dataset.timerSeconds) || 18000) * 1000;
    const storageKey = `casa-silp-countdown-${root.closest('.shopify-section')?.id || 'page'}`;
    let endTime = Number(sessionStorage.getItem(storageKey));

    if (!endTime || endTime <= Date.now()) {
      endTime = Date.now() + duration;
      sessionStorage.setItem(storageKey, String(endTime));
    }

    const render = () => {
      let remaining = endTime - Date.now();
      if (remaining <= 0) {
        endTime = Date.now() + duration;
        sessionStorage.setItem(storageKey, String(endTime));
        remaining = duration;
      }

      const totalSeconds = Math.floor(remaining / 1000);
      hours.textContent = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
      minutes.textContent = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
      seconds.textContent = String(totalSeconds % 60).padStart(2, '0');
    };

    render();
    root.cspTimer = window.setInterval(render, 1000);
  }

  function initialiseAll(scope = document) {
    scope.querySelectorAll('[data-casa-silp-page]').forEach(initialisePage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll());
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.querySelector('[data-casa-silp-page]');
    if (root?.cspTimer) window.clearInterval(root.cspTimer);
    if (!document.querySelector('[data-casa-silp-page][data-hide-chrome="true"]')) {
      document.body.classList.remove(BODY_CLASS);
    }
  });
})();
